import React from 'react'
import ProductsInventoryHeader from './ProductsInventoryHeader'
import ProductsInventoryInner from './ProductsInventoryInner'
import ProductsInventoryFooter from './ProductsInventoryFooter'
import { getWarehouses, getProductsInventory } from '../../../../ReportsFunctions'

export const productsInventoryControllerContext = React.createContext()

function useProductsInventoryController(props) {
  return ({
    filter: props.filter,
    getWarehouses,
    getProductsInventory
  })
}

function ProductsInventoryController(props) {
  const productsInventoryController = useProductsInventoryController(props)
  return (
    <React.Fragment>
      <productsInventoryControllerContext.Provider value={productsInventoryController}>
        <ProductsInventoryHeader />
        <ProductsInventoryInner />
        <ProductsInventoryFooter />
      </productsInventoryControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ProductsInventoryController)